<button mat-icon-button (click)="openDialog()">
    <mat-icon class="text-on-primary" [svgIcon]="'heroicons_outline:mail'"></mat-icon>
</button>